import React, {Component} from 'react';

import UserRecords from '../records';

class CabinetMain extends Component {
  render() {
    return (
      <div>
        <UserRecords />
      </div>
    )
  }
}

export default CabinetMain;



// WEBPACK FOOTER //
// ./src/cabinet/main/index.js